import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VscodeInstallService {
  static readonly extenstionUrl = 'https://marketplace.visualstudio.com/items?itemName=sysprompthub.sysprompthub'

  openExtensionPage(event?: Event) {
    event?.preventDefault()
    window.open(VscodeInstallService.extenstionUrl, '_blank', 'noopener')
  }
}
